<template>
  <div>
    <container-headline
      :headline="$t('global.internalinformation')"
      :col="6"
    ></container-headline>
    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div class="eingabe-panel-kopf p-3">
          <!--<div class="row">
            <div class="col-xl-6">
              <div class="form-group">
                <textarea
                  :disabled="!editable"
                  v-model="firma.hofangaben.referenz"
                  class="form-control"
                  rows="2"
                  style="resize: vertical"
                ></textarea>
                <label>{{ $t("global.reference") }}</label>
              </div>
            </div>
            <div class="col-xl-6">
              <div class="form-group">
                <textarea
                  :disabled="!editable"
                  v-model="firma.hofangaben.hofbesuch"
                  class="form-control"
                  rows="2"
                  style="resize: vertical"
                ></textarea>
                <label>{{ $t("global.farmvisits") }}</label>
              </div>
            </div>
          </div>-->
          <div class="row">
            <div class="col-xl-6">
              <div class="form-group">
                <textarea
                  :disabled="!editable"
                  v-model="firma.bemerkungen"
                  class="form-control"
                  rows="2"
                  style="resize: vertical"
                ></textarea>
                <label>{{ $t("global.remarks") }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline";

export default {
  name: "FirmaInterneAngabenNewViva",
  components: {
    ContainerHeadline,
  },
  mixins: [],
  props: {
    firma: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
};
</script>
